// api.js
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.URL || 'https://investcrypto-backend-0dd6c98c3a6e.herokuapp.com', // Replace with your backend URL
  // baseURL: 'http://localhost:8081', // Replace with your backend URL
});

export default api;
